import React from 'react';

import { ScrollReveal } from '../../ScrollReveal';
import { Asset } from '../../AtomicComponents/Asset';

import { NodeProps } from './shared';

export function AssetNode({ node }: NodeProps) {
  return node?.data?.target ? (
    <ScrollReveal>
      <Asset
        asset={node.data.target}
        className="my-6 max-w-full rounded-[3.5rem] tablet:my-8 tablet:rounded-[4rem]"
      />
    </ScrollReveal>
  ) : null;
}
